/*
 * @Descripttion: 
 * @version: 
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-10 09:34:03
 * @LastEditors: sj
 * @LastEditTime: 2022-02-10 16:19:56
 */
// /*
//  * @Descripttion:
//  * @version:
//  * @Author: sujun
//  * @email: 1373842098@qq.com
//  * @Date: 2022-01-10 09:34:03
//  * @LastEditors: sj
//  * @LastEditTime: 2022-01-10 17:48:28
//  */

import { createAsyncThunk } from '@reduxjs/toolkit'
import { sendAsync } from '../../app/applicationSlice'
import { RootThunkApi } from '../../app/store'
import * as S from '../../services/StatisticAnalysis'
import {ReplaceMakeOrderListBody} from "../../services/StatisticAnalysis";

// 代煎订单列表
export const getreplaceMakeOrderList = createAsyncThunk<
  void,
  S.ReplaceMakeOrderListBody,
  RootThunkApi<void>
>('recipeEditor/getreplaceMakeOrderList', async (params, api) => {
  return sendAsync(S.ReplaceMakeOrderList(params), api)
})

// 代煎订单列表合计行
export const getReplaceMakeOrderAmount = createAsyncThunk<
  void,
  S.ReplaceMakeOrderListBody,
  RootThunkApi<void>
>('recipeEditor/getReplaceMakeOrderAmount', async (params, api) => {
  return sendAsync(S.ReplaceMakeOrderAmount(params), api)
})

// 代煎订单详情
export const getReplaceMakeOrderDetail = createAsyncThunk<
  void,
  S.ReplaceMakeOrderDetailParams,
  RootThunkApi<void>
>('recipeEditor/ReplaceMakeOrderDetail', async (params, api) => {
  return sendAsync(S.ReplaceMakeOrderDetail(params), api)
})

// 数据统计
export const getReplaceMakeOrderStatisticAnalysis = createAsyncThunk<
  void,
  S.ReplaceMakeOrderStatisticAnalysisParams,
  RootThunkApi<void>
>('recipeEditor/ReplaceMakeOrderStatisticAnalysis', async (params, api) => {
  return sendAsync(S.ReplaceMakeOrderStatisticAnalysis(params), api)
})
